const formatAmount = (amount: string) => {
  if (/^-\d+/.test(amount)) {
    return `- $${amount.replace('-', '')}`
  }
  return `$${amount}`
}

export default formatAmount

export const getCurrencyString = (currency: string | undefined) => {
  return !!currency ? (currency === 'USD' ? '' : currency) : ''
}
